<div class="approval-flow-selector">
  <div class="selector-header">
    <h4><i class="fas fa-route"></i> 簽核流程選擇</h4>
    <p class="header-description">選擇適合此表單的簽核流程</p>
  </div>

  <!-- 載入狀態 -->
  <div *ngIf="loading" class="loading-state">
    <i class="fas fa-spinner fa-spin"></i>
    <span>載入中...</span>
  </div>

  <!-- 錯誤狀態 -->
  <div *ngIf="error" class="error-state">
    <i class="fas fa-exclamation-triangle"></i>
    <span>{{ error }}</span>
    <button class="retry-btn" (click)="loadFlowDefinitions()" title="重新載入">
      <i class="fas fa-redo"></i>
    </button>
  </div>

  <!-- 簽核流程清單 -->
  <div *ngIf="!loading && !error" class="flow-list">
    <div *ngIf="flowDefinitions.length === 0" class="empty-state">
      <i class="fas fa-info-circle"></i>
      <span>目前沒有可用的簽核流程</span>
    </div>

    <div 
      *ngFor="let flow of flowDefinitions" 
      class="flow-item"
      [class.selected]="isFlowSelected(flow)"
      (click)="selectFlow(flow)"
      [title]="flow.description"
    >
      <div class="flow-header">
        <div class="flow-name">
          <i class="fas fa-check-circle selection-indicator" *ngIf="isFlowSelected(flow)"></i>
          <i class="far fa-circle selection-indicator" *ngIf="!isFlowSelected(flow)"></i>
          <span class="name">{{ flow.name }}</span>
        </div>
        <div class="flow-status">
          <span class="status-badge status-active">啟用中</span>
        </div>
      </div>

      <div class="flow-description" *ngIf="flow.description">
        {{ flow.description }}
      </div>

      <div class="flow-details">
        {{ getFlowDisplayText(flow) }}
      </div>

      <!-- 流程步驟預覽 -->
      <div class="flow-steps-preview" *ngIf="isFlowSelected(flow) && flow.steps?.length">
        <div class="steps-header">
          <i class="fas fa-list"></i>
          <span>簽核步驟:</span>
        </div>
        <div class="steps-list">
          <div 
            *ngFor="let step of flow.steps; let i = index" 
            class="step-item"
          >
            <span class="step-order">{{ step.order }}</span>
            <span class="step-name">{{ step.name }}</span>
            <span class="step-approver" *ngIf="step.approverType === 'role_based'">
              ({{ step.roleName || '角色' }})
            </span>
            <span class="step-approver" *ngIf="step.approverType === 'specific_user'">
              ({{ step.userName || '特定使用者' }})
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 選擇狀態摘要 -->
  <div class="selection-summary" *ngIf="selectedFlow">
    <div class="summary-header">
      <i class="fas fa-info-circle"></i>
      <span>已選擇流程</span>
    </div>
    <div class="summary-content">
      <strong>{{ selectedFlow.name }}</strong>
      <span class="summary-details">{{ getFlowDisplayText(selectedFlow) }}</span>
    </div>
  </div>
</div>